const ReservationType = `
  id
  description
`;

export default ReservationType;
